import { useQuery } from '@tanstack/react-query';
import { listCalibrationRuns } from '../api/api';
import { QK } from '../lib/query-keys';
import { useCurrentBotId } from './use-current-bot-id';

export function useCalibrationRuns() {
  const botId = useCurrentBotId();
  return useQuery({
    // botId in the key (not just the queryFn) so a bot switch is treated as a
    // new query and refetches immediately, instead of continuing to show the
    // previous bot's cached runs until something else invalidates it.
    queryKey: QK.calibration.runs.list(botId),
    queryFn: ({ signal }) => listCalibrationRuns(signal),
  });
}
